import { RouteComponentProps, useHistory } from "react-router-dom";
import { PayerRequirementDetails } from "./PayerRequirementDetails";
import { WSPage } from "@wingspanhq/fe-component-library";
import { WSQueries } from "../../../../../query/WSQuery";
import { usePayerQuery } from "../../../../../query/payers/queries/usePayerQuery";
import { Fullscreen } from "../../../../../components/Fullscreen/Fullscreen";
import { useRequirementQuery } from "../../../../../query/requirements/queries/useRequirementQuery";
import { useHistoryCheckpoint } from "../../../../../shared/hooks/useHistoryCheckpoint";

export const DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH =
  "/member/dashboard/payer/:payerId/requirement/:requirementId";

export const useGoToDashboardPayerRequirementDetails = () => {
  const history = useHistory();
  const historyCheckpoint = useHistoryCheckpoint(
    DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH
  );

  return (params: { payerId: string; requirementId: string }) => {
    historyCheckpoint.saveCheckpoint();

    history.push(
      DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH.replace(
        ":payerId",
        params.payerId
      ).replace(":requirementId", params.requirementId)
    );
  };
};

export const RoutePayerRequirementDetails: React.FC<
  RouteComponentProps<{
    payerId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId, payerId }
  }
}) => {
  const queryPayer = usePayerQuery(payerId);
  const queryRequirement = useRequirementQuery(requirementId);

  return (
    <Fullscreen>
      <WSPage>
        <WSQueries
          queries={{
            queryPayer,
            queryRequirement
          }}
        >
          {({ queryPayerData, queryRequirementData }) => {
            return (
              <PayerRequirementDetails
                payer={queryPayerData}
                requirement={queryRequirementData}
              />
            );
          }}
        </WSQueries>
      </WSPage>
    </Fullscreen>
  );
};
